import { Dialog, DialogContent } from "@mui/material";

import ConfigModal from "./ConfigModal";

function OperatorTableInfoModal({
  open,
  onClose,
  modalType,
  modalRef,
  headers,
  visibleColumns,
  setVisibleColumns,
}) {
  const renderContent = () => {
    switch (modalType) {
      case "config":
        return (
          <ConfigModal
            onClose={onClose}
            headers={headers}
            visibleColumns={visibleColumns}
            setVisibleColumns={setVisibleColumns}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      ref={modalRef}
      maxWidth="lg"
      fullWidth
    >
      <DialogContent sx={{ borderRadius: "15px" }} className="rmui-card">
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
}

export default OperatorTableInfoModal;
